const headerLinkStyle = (theme) => ({
  headerLinkContainer: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-end",
      overflow: "scroll",
    },
  },
  itemContainer: {
    padding: 9,
    transition: "all .1s ease",
    [theme.breakpoints.down("sm")]: {
      borderBottom: "1px solid #999999",
      "&:hover": {
        backgroundColor: "#f3f3f3",
      },
    },
    [theme.breakpoints.up("md")]: {
      width: 90,
    },
  },
  link: {
    fontFamily: "Lemonada",
    color: "black",
    textDecoration: "none",
    transition: "all .1s ease",
    "&:hover": {
      color: "#87ceeb",
    },
  },
});

export default headerLinkStyle;
